import React, { useRef, useEffect, useState } from "react";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import { connect } from "react-redux";
import {
  Modal,
  Col,
  Row,
  Overlay,
  Button,
  Popover,
  Container,
  FormLabel,
} from "react-bootstrap";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import CustomDataTable from "../../../layouts/DataTables/CustomDataTable";
import axios from "../../../apis/Api";
import { getDropdownList, getDropdownListByPost } from "../../Shared/dropdownListActions";
import {
  GET_DISTRIBUTOR_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
  GET_PAYMENT_TYPES_DDL,
} from "../../../Types";
import FormikControl from "../../../layouts/Input/FormikControl";
import { Formik, Form } from "formik";
import { Link } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import storage from "../../../apis/Storage";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { useHistory } from "react-router-dom";
import { formatDate, renderCell, renderHeader, toCommaSeparated } from "../../../utilities/FUNCTIONS";
import Moment from "react-moment";
import { TextRight } from "react-bootstrap-icons";
import { date } from "yup";
export const showLoader = () => async (dispatch) => {
  dispatch(showLoading());
};

export const hideLoader = () => async (dispatch) => {
  dispatch(hideLoading());
};

const InvoiceReopeningListing = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));
  const [invoiceList, setInvoiceList] = useState([]);
  const [deliveryManFilterList, setDeliveryManFilterList] = useState([]);

  //Pagination
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const [showInvoices, setShowInvoices] = useState(false);
  const [targetInvoices, setTargetInvoices] = useState(null);
  const refInvoices = useRef(null);

  const [distributorList, setDistributorList] = useState([]);
  const [distCenterList, setdistCenterList] = useState([]);
  const [deliveryManNameList, setDeliveryManNameList] = useState([]);
  const [filterMfi, setFilterMfi] = useState(null);
  const [showInvoiceReopeningModal, setShowInvoiceReopeningModal] =
    useState(false);
  const [allDeliveryManList, setAllDeliveryManList] = useState([]);

  const [filter, setfilter] = useState({
    distributor: [],
    distCenter: [],
    deliveryManName: [],
    mfi: [],
    shopCode: null,
    invoiceNo: null,
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    searchText: null,
  });

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  function formRequestObject() {
    let requestData = {
      distributor: toCommaSeparated(filter.distributor),
      distCenter: toCommaSeparated(filter.distCenter),
      deliveryManTillNo: filter.deliveryManTillNo?.value,
      invoiceNo: filter.invoiceNo,
      shopCode: filter.vizshopCode,
      mfi: toCommaSeparated(filter.mfi),
      deliveryManName: toCommaSeparated(filter.deliveryManName),
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.toDate && formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: filter.pageNo,
      searchText: filter.searchText,
    };

    return requestData;
  }

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setfilter({ ...filter, searchText: text, currentPageNo: 0 });
    var request = {
      ...formRequestObject(),
      searchText: text,
      currentPageNo: 0,
    };
    fetchReportData(request);
  };

  function fetchReportData(request) {
    let finalRequest = request == null ? formRequestObject() : request;
    getInvoiceList(finalRequest);
  }

  const getInvoiceList = (request) => {
    props.showLoader();
    axios
      .post(`api/TransactionReopening/GetReopenTransactionListing`, request)
      .then(({ data }) => {
        props.hideLoader();
        setInvoiceList(data?.response?.data);
        setTotalRecords(data?.response?.totalRecords);
      })
      .catch(function (error) {
        props.hideLoader();
      });
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    var request = { ...formRequestObject(), pageNo: page };
    fetchReportData(request);
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    var request = { ...formRequestObject(), pageNo: 0, pageSize: pageSize };
    fetchReportData(request);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setDeliveryManFilterList([]);
    setdistCenterList([]);
    setDeliveryManNameList([]);

    setfilter({
      distributor: [],
      distCenter: [],
      deliveryManName: [],
      mfi: [],
      shopCode: "",
      invoiceNo: "",
      vizshopCode: "",
      fromDate: new Date(),
      toDate: new Date(),
      pageNo: 0,
      searchText: null,
    });

    setInvoiceList([]);
  };


  // reopen transaction View Model

  const [invoiceOpeningModalInitialValue, setInvoiceOpeningModalInitialValue] =
    useState({
      distributor: "",
      distCenterName: "",
      shopCode: "",
      invoiceAmount: "",
      paymentType: "",
      payerName: "",
      tidNO: "",
      createdDate: "",
      vizShopId: "",
      invoiceNo: "",
      paidAmount: "",
      distBank: "",
      payerBank: "",
      image: "",
      deliveryMan: "",
      distCenterId: "",
      transactionId: "",
    });

  const invoiceReopeningHandler = (data) => {
    //debugger;
    getCenterDeliveryUsers(invoiceOpeningModalInitialValue.distCenter);
  };

  const invoiceReopeningSubmitHandler = (data) => {
    let req = {
      invoiceNumber: invoiceOpeningModalInitialValue.invoiceNo,
      deliveryManId: data.deliveryManId,
      transactionId: invoiceOpeningModalInitialValue.transactionId,
    };

    axios
      .post(`api/TransactionReopening/ReOpenedTransactionUpdate`, req)
      .then(({ data }) => {
        toast.success("Invoice Re-Opened successfully");
        setShowInvoiceReopeningModal(false);
        fetchReportData();
      })
      .catch(function (error) { });
  };

  // For Double Click
  const onRowClick = (e, rowData) => {
    if (rowData.paymentType.toLowerCase() === "rtg" || rowData.paymentType.toLowerCase() === "additional sales" || rowData.paymentType.toLowerCase() === "withholding tax" || rowData.paymentType.toLowerCase() === "market return") {
      var adjustment = true;
    }

    // Get today's local date in yyyy-mm-dd
    const today = new Date().toLocaleDateString("en-CA"); // "en-CA" gives yyyy-mm-dd format

    const orderDate = rowData.orderDeliveryDate.split("T")[0]; // date only

    if (orderDate === today) {
      toast.error("Today's invoices cannot be reopened.");
      return;
    }

    if (rowData.transactionReopen?.toLowerCase() === "yes" || rowData.invoiceType?.toLowerCase() !== "non vizlink") {

      return;
    }
    if (rowData.invoiceNature.toLowerCase() === "credit" && adjustment) {
      toast.error("This invoice is credited invoice so you cannot be reopened its adjustments.");
      return;
    }
    if (rowData.invoiceNature.toLowerCase() === "credit" && rowData.isCreditFinlized && rowData.paymentType.toLowerCase() == "credit") {
      toast.error("Reopening is not allowed since a payment has been applied to this credit invoice.");
      return
    }
    axios
      .get(`api/TransactionReopening/GetReopenTransactionDetail/${rowData.id}`)
      .then(({ data }) => {
        var result = data?.response?.data;
        //debugger
        setInvoiceOpeningModalInitialValue({
          distributor: result.distributorName,
          distCenterName: result.distCenterName,
          shopCode: result.shopCode,
          invoiceAmount: result.invoiceAmount,
          paymentType: result.paymentType,
          payerName: result.payerName,
          tidNO: result.tidNO,
          createdDate: result.createdDate,
          vizShopId: result.vizShopId,
          invoiceNo: result.invoiceNo,
          paidAmount: result.paidAmount,
          distBank: result.distBank,
          payerBank: result.payerBank,
          image: result.image,
          deliveryMan: result.deliveryMan,
          distCenterId: result.distCenterId,
          transactionId: result.transactionId,
        });
      })
      .catch(function (error) { });

    setShowInvoiceReopeningModal(true);
  };

  const columns = [
    {
      Header: "Shop Code/Viz ID",
      accessor: "shopCodeVizId",
    },
    // {
    //   Header: "Customer Name",
    //   accessor: "vizShopName",
    // },
    {
      Header: "DLM",
      accessor: "dlmName",
    },

    {
      Header: "Invoice No.",
      accessor: "vizproInvoiceNo",
    },
    {
      Header: "Order Date",
      accessor: "orderDeliveryDate",
      Cell: (row) => (
        <div style={{ width: "75px" }}>
          <Moment format="DD/MM/YYYY">{row.value}</Moment>
        </div>
      ),
    },
    {
      Header: "Invoice Type",
      accessor: "invoiceNature",
    },
    {
      Header: "Payment Type",
      accessor: "paymentType",
      Cell: ({ value }) => (value?.toLowerCase() === "onebill" ? "1Bill" : value),
    },


    {
      Header: "Payment Date",
      accessor: "createdDate",
      Cell: (row) => (
        <div style={{ width: "75px" }}>
          <Moment format="DD/MM/YYYY">{row.value}</Moment>
        </div>
      ),
    },
    {
      Header: renderHeader("Inv Amount", true),
      accessor: "invoiceAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Paid Amount", true),
      accessor: "paidAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: "Reopened",
      accessor: "transactionReopen",
    },
  ];

  useEffect(() => {
    fetchReportData();
    getAllDeliveryUserList();
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
  }, []);

  const getAllDeliveryUserList = () => {
    axios
      .get(`api/User/GetAllDeliveryUsers`)
      .then(({ data }) => {
        setAllDeliveryManList(data?.response);
      })
      .catch(function (error) { });
  };

  function deliveryDropDown(centerId) {
    const dUsersList = [...(allDeliveryManList || [])];
    if (!centerId) {
      return dUsersList.map((item) => ({
        value: item.id,
        label: item?.fullname,
      }));
    } else {
      const centerUsers = dUsersList
        .filter(
          (x) =>
            x.distCenterId?.toString().toLowerCase() ===
            centerId?.toString().toLowerCase()
        )
        .map((item) => ({
          value: item.id,
          label: item?.fullname,
        }));

      return centerUsers;
    }
  }

  useEffect(() => {
    props.getDropdownList(
      `api/ShopOrderTransaction/GetPaymentTypes`,
      GET_PAYMENT_TYPES_DDL
    );
  }, []);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId
      );
      if (distributorList?.length > 0) {
        setfilter({
          ...filter,
          distributor: {
            label: distributorList[0]?.label,
            value: distributorList[0]?.value,
          },
        });
      }
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
    else if (userRights != null && userRights?.userType == "CoreAppUser") {
      let distributorList = props.allDistributorList.filter((x) =>
        userRights?.distributorId.includes(x.value)
      );
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setDistributorList(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distCenterList = props.selectedAddJobDistCentersList.filter((x) =>
        userRights?.distCenterIds.includes(x.value)
      );
      setdistCenterList(
        distCenterList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setdistCenterList(
        props.selectedAddJobDistCentersList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.selectedAddJobDistCentersList]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        { distributorIds: toCommaSeparated(userRights?.distributorId) },
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL
      );
    }
    if (!filter.distributor || filter.distributor.length > 0) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        { distributorIds: toCommaSeparated(filter.distributor) },
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL
      );
    } else {
      filter.distCenter = [];
      filter.deliveryManName = [];
      filter.deliveryManTillNo = null;
    }
  }, [filter.distributor]);

  useEffect(() => {
    filter.deliveryManName = null;
    filter.deliveryManTillNo = null;
  }, [filter.distCenter]);

  const getCenterDeliveryUsers = (id) => {
    axios
      .get(`api/DistCenter/GetCenterDeliveryUsersDDL/${id}`)
      .then(({ data }) => {
        if (data?.response) {
          setDeliveryManNameList(
            data.response.map(function (item) {
              return {
                value: item.qrCode,
                label: item.fullname,
              };
            })
          );
        }
      })
      .catch(function (error) { });
  };

  useEffect(() => {
    if (!filter.distCenter || filter.distCenter.length > 0) {
      getCenterDeliveryUsers(toCommaSeparated(filter.distCenter));
    }
  }, [toCommaSeparated(filter.distCenter)]);

  return (
    <div>
      <VzPageContainer title="Daily Orders > Transaction Re-Opening">
        <Row>
          <Col md={{ span: 3 }} style={{ float: "left" }}>
            <h4>
              <b>Transaction Re-Opening</b>
            </h4>
          </Col>
        </Row>
        <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      validator={() => ({})}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            {(userRights == null || userRights?.userType == 'CoreAppUser') && (
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  label="Distributor"
                                  name="distributor"
                                  options={distributorList}
                                  isMulti={true}
                                  isClearable={true}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    setfilter({
                                      ...filter,
                                      distributor: e || [],
                                      distCenter: [],
                                      deliveryManName: []
                                    });
                                  }}
                                  value={filter.distributor}
                                />
                              </Col>
                            )}
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distribution Center"
                                name="distributionCenter"
                                options={distCenterList}
                                isMulti={true}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    distCenter: e || [],
                                    deliveryManName: []
                                  });
                                }}
                                value={filter.distCenter}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Deliveryman Name"
                                name="deliverymanName"
                                options={deliveryManNameList}
                                isMulti={true}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    deliveryManName: e || [],
                                  });
                                }}
                                value={filter.deliveryManName}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Payment Type"
                                name="mfi"
                                options={props.paymentTypeList
                                  .map((x) => ({
                                    ...x,
                                    label: x.label.toLowerCase() === "onebill" ? "1Bill" : x.label,
                                  }))}
                                isMulti={true}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    mfi: e || [],
                                  });
                                }}
                                value={filter.mfi}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="Shop Code / Viz-ID"
                                name="shopCode"
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    vizshopCode: e,
                                  });
                                }}
                                value={filter.vizshopCode}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="Invoice No."
                                name="invoiceNo"
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    invoiceNo: e,
                                  });
                                }}
                                value={filter.invoiceNo}
                              />
                            </Col>

                            <Row style={{ paddingRight: 0 }}>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  formik={formik}
                                  type="fromDate"
                                  control="date"
                                  label="From Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, fromDate: value });
                                  }}
                                  value={filter.fromDate}
                                />
                              </Col>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  formik={formik}
                                  control="date"
                                  type="toDate"
                                  label="To Date"
                                  name="toDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, toDate: value });
                                  }}
                                  value={filter.toDate}
                                />
                              </Col>
                            </Row>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} ref={refInvoices}>
            <ServerSideDataTable
              data={invoiceList ?? []}
              columns={columns}
              getTrProps={(event, data) => onRowClick(event, data)}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords ?? 0}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
              searchLabel="Search Invoice :"
              PageTableName="InvoiceReOpening"
            />
          </Col>
        </Row>
        {/* //// Invoice Re-Opening Modal */}
        <Modal
          show={showInvoiceReopeningModal}
          onHide={() => {
            setShowInvoiceReopeningModal(false);
          }}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Invoice Re-Opening
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              enableReinitialize
              initialValues={invoiceOpeningModalInitialValue}
              onSubmit={invoiceReopeningSubmitHandler}
            >
              {(formik) => (
                <Form
                  autoComplete="off"
                  encType="multipart/form-data"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <Container>
                    <Row>
                      <Col md={3}>
                        <FormLabel>Distributor :</FormLabel>
                      </Col>
                      <Col md={3}> {formik.values.distributor || ""} </Col>
                      <Col md={3}>
                        <FormLabel>Date :</FormLabel>
                      </Col>
                      <Col md={3}>
                        <Moment format="DD/MM/YYYY">
                          {formik.values.date}
                        </Moment>
                      </Col>
                      <Col md={3}>
                        <FormLabel>Dist Center :</FormLabel>
                      </Col>
                      <Col md={3}>{formik.values.distCenterName || ""}</Col>
                      <Col md={3}>
                        <FormLabel>VIZ ID :</FormLabel>
                      </Col>
                      <Col md={3}>{formik.values.vizShopId || ""}</Col>
                      <Col md={3}>
                        <FormLabel>Shop Code :</FormLabel>
                      </Col>
                      <Col md={3}>{formik.values.shopCode || ""}</Col>
                      <Col md={3}>
                        <FormLabel>Invoice No :</FormLabel>
                      </Col>
                      <Col md={3}>{formik.values.invoiceNo || ""}</Col>
                      <Col md={3}>
                        <FormLabel>Invoice Amount :</FormLabel>
                      </Col>
                      <Col md={3}>{formik.values.invoiceAmount || ""}</Col>
                      <Col md={3}>
                        <FormLabel>Paid Amount :</FormLabel>
                      </Col>
                      <Col md={3}>{formik.values.paidAmount || ""}</Col>

                      {formik.values.paymentType && (
                        <>
                          <Col md={3}>
                            <FormLabel>Payment Type :</FormLabel>
                          </Col>
                          <Col md={3}>{formik.values.paymentType}</Col>
                        </>
                      )}
                      {formik.values.distBank && (
                        <>
                          <Col md={3}>
                            <FormLabel>Dist Bank :</FormLabel>
                          </Col>
                          <Col md={3}>{formik.values.distBank || ""}</Col>
                        </>
                      )}

                      {formik.values.payerName && (
                        <>
                          <Col md={3}>
                            <FormLabel>Payer Name :</FormLabel>
                          </Col>
                          <Col md={3}>{formik.values.payerName || ""}</Col>
                        </>
                      )}
                      {formik.values.payerBank && (
                        <>
                          <Col md={3}>
                            <FormLabel>Payer Bank :</FormLabel>
                          </Col>
                          <Col md={3}>{formik.values.payerBank || ""}</Col>
                        </>
                      )}
                      {formik.values.tidNO && (
                        <>
                          <Col md={3}>
                            <FormLabel>TID # :</FormLabel>
                          </Col>
                          <Col md={3}>{formik.values.tidNO || ""}</Col>
                        </>
                      )}
                      {formik.values.image && (
                        <>
                          <Col md={3}>
                            <FormLabel>Image Uploaded :</FormLabel>
                          </Col>
                          <Col md={3}>
                            <img
                              className="kyc-form-img"
                              style={{ border: "1px solid #ccc" }}
                              alt="not fount"
                              width={"125px"}
                              height={"125px"}
                              src={formik.values.image}
                            />
                          </Col>
                        </>
                      )}
                      <Col md={3}>
                        <FormLabel>Deliveryman Name :</FormLabel>
                      </Col>
                      <Col md={3}>
                        <ReactSelect
                          isDisabled={true}
                          id="deliverymanName"
                          name="deliverymanName"
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="Select Delivery Man"
                          isMulti={false}
                          value={deliveryDropDown(
                            formik.values.distCenterId
                          ).find(
                            (opt) => opt.label === formik.values.deliveryMan
                          )}
                          isSearchable={true}
                          options={deliveryDropDown(formik.values.distCenterId)}
                          menuPlacement="auto"
                          onChange={(option) =>
                            formik.setFieldValue("deliveryMan", option.value)
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} md={12} style={{ textAlign: "right" }}>
                        <Button
                          className="btn btn-default"
                          style={{ marginTop: "10px", marginRight: "20px" }}
                          onClick={() => {
                            setShowInvoiceReopeningModal(false);
                          }}
                        >
                          Cancel
                        </Button>
                        <input
                          type="submit"
                          className="btn btn-primary"
                          style={{
                            marginRight: "10px",
                            marginTop: "10px",
                          }}
                          value="Re-Open"
                        />
                      </Col>
                    </Row>
                  </Container>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    selectedAddJobDistCentersList: state.ddlList.selectedAddJobDistCentersList
      ? state.ddlList.selectedAddJobDistCentersList
      : [],
    paymentTypeList: state.ddlList.paymentTypeList,
  };
};
export default connect(mapStateToProps, {
  getDropdownList,
  getDropdownListByPost,
  showLoader,
  hideLoader,
})(InvoiceReopeningListing);
